<template>
    <div class="flex flex_end w_100">
        <template v-for="item in realList">
			<PaymentProgressStatusBox :status-code="item.status.code"
									  :status-tooltip="item.tip"
									  :with-click="true"
									  @click="expandDetails"
									  :key="item.index"
			/>
        </template>
    </div>
</template>

<script>
import {paymentProgress} from "@/common/utils/paymentProgress";
import PaymentProgressStatusBox from "@/components/templates/common/payments/PaymentProgressStatusBox";

export default {
	components: {
		PaymentProgressStatusBox
	},
    data() {
        return {
            tipList: [
                { index: 1, tip: this.$t("investor.payments.details.closingFee.title")},
                { index: 2, tip: this.$t("investor.payments.details.progress.investorToSeller.tooltip")},
                { index: 3, tip: this.$t("investor.payments.details.progress.sellerToInvestor.tooltip")}
            ]
        };
    },
    methods: {
        expandDetails() {
	        if (this.params.data.index === undefined) {
		        return;
	        }

            this.params.api.setRowNodeExpanded(this.params.node, !this.params.node.expanded);
        }
    },
    computed: {
        realList() {
            let { data } = this.params;
            let {
	            closingFeePaymentStatus,
                buyerToSellerPaymentStatus,
                sellerToBuyerPaymentStatus,
                buyerToSellerAmountAlreadyPaid,
                buyerToSellerAmountRequested,
                buyerToSellerAmountExpected,
	            buyerAmountAlreadyReceived,
                dueDate
            } = data;

            let tipList = this.tipList;
            tipList = tipList.map((item, n) => {
                switch (n) {
                    case 0:
                    	item.status = paymentProgress.getStatusForFee(closingFeePaymentStatus);
                        break;
                    case 1:
                    	item.status = paymentProgress.getStatusForSettlement(null, buyerToSellerPaymentStatus, buyerToSellerAmountAlreadyPaid, buyerToSellerAmountRequested, buyerToSellerAmountExpected);
                        break;
                    case 2:
                    	item.status = paymentProgress.getStatusForSettlement(dueDate, sellerToBuyerPaymentStatus, buyerAmountAlreadyReceived);
                        break;
                    default:
                        break;
                }
                return item;
            });

            return tipList.filter(item => item.status !== null);
        }
    }
};
</script>